var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Avatar bg-primary-400",style:({width: (_vm.radius * 2) + 'px', height: (_vm.radius *2) + 'px', 'font-size': (_vm.radius * 0.7) + 'px'})},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }